import {Component, input, output, signal} from '@angular/core';
import {Button} from 'primeng/button';
import {Tooltip} from 'primeng/tooltip';
import {TranslocoPipe} from '@jsverse/transloco';
import {CommentModalXComponent} from '../comment-modal-x/comment-modal-x.component';
import {CommentContainer} from '../comment-modal-x/comment-container';

@Component({
  selector: 'app-comment-modal-button-model',
  imports: [Button, Tooltip, TranslocoPipe, CommentModalXComponent],
  templateUrl: './comment-modal-button-model.component.html',
})
export class CommentModalButtonModelComponent {
  value = input<string | null>(null);
  isReadOnly = input<boolean>(false);

  valueChange = output<string>();

  protected modalVisible = signal(false);
  protected activeCommentContainer = signal<CommentContainer>({comment: ''});

  protected openModal(): void {
    this.activeCommentContainer.set({comment: this.value() ?? ''});
    this.modalVisible.set(true);
  }

  protected onSave(value: string): void {
    if (!this.isReadOnly()) {
      this.valueChange.emit(value);
    }
  }
}
